import React, { useEffect } from 'react';
import { styled } from '@compiled/react';
import Badge from '@atlaskit/badge';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { borderRadius } from '@atlassian/jira-common-styles/src/main.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useObjectStoreState } from '@atlassian/jira-servicedesk-insight-object-details-store/src/controllers/store/index.tsx';
import { messages } from './messages.tsx';

type Props = {
	numHiddenAttributes: number;
};

export const EmptyAttributesInformation = (props: Props) => {
	const { formatMessage } = useIntl();
	const [, { setHideEmptyAttributesState }] = useObjectStoreState();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireUIAnalytics(
			createAnalyticsEvent({}),
			'panel displayed',
			'hideEmptyCmdbObjectAttributesPanel',
		);
	}, [createAnalyticsEvent]);
	return (
		<Container>
			<TextContainer>{formatMessage(messages.emptyAttributesHidden)}</TextContainer>
			<Badge appearance="primary">{props.numHiddenAttributes}</Badge>
			<Button appearance="link" onClick={() => setHideEmptyAttributesState(false)}>
				{formatMessage(messages.show)}
			</Button>
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.accent.gray.subtlest'),
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextContainer = styled.p({
	paddingTop: 0,
	paddingRight: token('space.100'),
	paddingBottom: 0,
	paddingLeft: token('space.100'),
});
